module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/changelog-192.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/changelog.md
// module id = 635
// module chunks = 459